"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultTheme = void 0;
const styles_1 = require("material-ui/styles");
exports.defaultTheme = styles_1.createMuiTheme({
    palette: {
        primary: {
            contrastText: '#fff',
            main: '#00c079',
        },
        secondary: {
            contrastText: '#fff',
            light: '#48bac9',
            main: '#226c9d',
        },
    },
    overrides: {
        MuiAppBar: {
            colorPrimary: {
                backgroundColor: '#132244',
            },
            root: {
                zIndex: 9001,
            },
        },
        MuiAvatar: {
            colorDefault: {
                backgroundColor: 'rgba(255, 255, 255, 0.54)',
            },
            root: {
                height: '30px',
                width: '30px',
            },
        },
        MuiBackdrop: {
            root: {},
        },
        MuiButton: {
            root: {
                background: 'transparent',
                border: 0,
                borderRadius: 2,
                boxShadow: 'none',
                color: 'rgba(0, 0, 0, 0.87)',
                height: 36,
                letterSpacing: '1px',
                padding: '9px',
            },
        },
        MuiDrawer: {
            modal: {
                width: 'fit-content',
            },
            paper: {
                height: '100%',
                position: 'fixed',
                zIndex: 2,
            },
        },
        MuiFormControl: {
            root: {},
        },
        MuiFormLabel: {
            disabled: {
                color: 'blue',
            },
            root: {
                padding: '25px 10px',
                marginTop: '-15px',
            },
            error: {
                color: '#d81b60',
            },
        },
        MuiTable: {
            root: {
                fontFamily: 'Heebo, sans-serif',
                fontWeight: 300,
            },
        },
        MuiTableSortLabel: {
            root: {
                fontWeight: 300,
            },
        },
    },
});



//////////////////
// WEBPACK FOOTER
// ./src/client/components/material/theme/default.ts
// module id = 2475
// module chunks = 0 1